import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  booking: generateApiPath({ prefix: AuthLevel.PUBLIC, name: 'booking' }),
}

export { paths }
